import { FieldNames, PricingDrawerActions } from '../../types';
import getUpdatedFields from '../get-updated-fields';
import submitUpdatedRefineFields from '../../../../utils/submit-updated-refine-fields';

type Params = {
  actions: PricingDrawerActions;
  formValues: {
    [key in FieldNames]?: any;
  };
  initialValues: {
    [key in FieldNames]?: any;
  };
  customer: {
    scale: string;
    rebate: boolean;
  };
};

const buildSubmitHandler = ({ actions, formValues, initialValues, customer }: Params) => {
  const { scale, rebate } = customer;
  const updatedFields = getUpdatedFields({ formValues, initialValues, scale });
  submitUpdatedRefineFields({ actions, rebate, scale, updatedFields });
  actions.customer.changeHasRefinedPrice(true);
  actions.drawer.closeDrawer();
};

export default buildSubmitHandler;
